import React from "react";
import { Control, Controller, RegisterOptions } from "react-hook-form";

import { FieldWrapper, FieldWrapperProps, InputFieldProps } from "shared/components";
import { InputFieldWrapper, StyledInputField } from "../styles";

interface Props extends FieldWrapperProps, InputFieldProps {
  control: Control;
  validation?: RegisterOptions;
  value?: string | null;
}

export const ControlledTextField: React.FC<Props> = ({
  control,
  validation,
  error,
  disabled,
  readOnly,
  name,
  value,
  placeholder,
  ...props
}) => {
  return (
    <FieldWrapper name={name} error={error} {...props}>
      <Controller
        name={name}
        control={control}
        rules={validation}
        render={({ onChange }) => (
          <InputFieldWrapper>
            <StyledInputField
              type="text"
              id={name}
              name={name}
              placeholder={placeholder}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                const value = e.target.value;

                onChange(value);
              }}
              value={value || ""}
              disabled={disabled}
              readOnly={readOnly}
            />
          </InputFieldWrapper>
        )}
      />
    </FieldWrapper>
  );
};
